import { render, staticRenderFns } from "./tab-time-log-starter.vue?vue&type=template&id=3fa07228&scoped=true&"
import script from "./tab-time-log-starter.vue?vue&type=script&lang=js&"
export * from "./tab-time-log-starter.vue?vue&type=script&lang=js&"
import style0 from "./tab-time-log-starter.vue?vue&type=style&index=0&id=3fa07228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa07228",
  null
  
)

export default component.exports